import { SubscriptionsMapper } from './SubscriptionsMapper.js';
import { SubscriptionFeatureBehavioursMapper } from './SubscriptionFeatureBehaviours/SubscriptionFeatureBehavioursMapper.js';

class SubscriptionsRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  getSubscriptionPlans() {
    return this.apiClient.get('/pro/subscriptions/plans').then(response => {
      return response.data.map(res => SubscriptionsMapper.createSubscriptionPlanModelFromResponse(res));
    });
  }
  getClientSubscriptions() {
    let pullFromRecurlyIfNotPresent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return this.apiClient.get('pro/subscriptions/client', {
      pullFromRecurlyIfNotPresent
    }).then(response => response.data.map(res => SubscriptionsMapper.createSubscriptionModelFromResponse(res)));
  }
  editClientSubscription(_ref) {
    let {
      paymentMethodId
    } = _ref;
    return this.apiClient.put('pro/subscriptions/client', {
      payment_method_id: paymentMethodId
    }).then(response => SubscriptionsMapper.createSubscriptionModelFromResponse(response.data));
  }
  cancelClientSubscription() {
    return this.apiClient.put('pro/subscriptions/client/cancel').then(response => response.data);
  }
  getRetentionDiscountEligibility() {
    return this.apiClient.get('pro/subscriptions/client/retention-discount/eligibility').then(response => SubscriptionsMapper.createSubscriptionRetentionDiscountFromResponse(response.data));
  }
  applyRetentionDiscount() {
    return this.apiClient.post('/pro/subscriptions/client/retention-discount/redeem').then(response => SubscriptionsMapper.createAppliedRetentionDiscountFromResponse(response.data));
  }
  createClientSubscription(_ref2) {
    let {
      paymentMethodId,
      planCode
    } = _ref2;
    return this.apiClient.post('pro/subscriptions/client', {
      payment_method_id: paymentMethodId,
      plan_code: planCode
    }).then(response => SubscriptionsMapper.createSubscriptionModelFromResponse(response.data));
  }
  getSubscriptionFeatureBehaviours() {
    return this.apiClient.get('pro/subscription-feature-behaviours').then(response => SubscriptionFeatureBehavioursMapper.createSubscriptionFeatureBehavioursFromResponse(response.data));
  }
  getSubscriptionPlanPrice(planCode) {
    return this.apiClient.get(`pro/subscriptions/plans/${planCode}/price`).then(response => SubscriptionsMapper.createSubscriptionPlanPriceFromResponse(response.data));
  }
  getAvailablePlanFeatures() {
    return this.apiClient.get(`pro/subscriptions/features`).then(response => SubscriptionFeatureBehavioursMapper.createSubscriptionPlanFeaturesFromResponse(response.data));
  }
}

export { SubscriptionsRepository };
//# sourceMappingURL=SubscriptionsRepository.js.map
